import React from 'react';
import { ShieldCheckIcon, ZapIcon, UsersIcon, AwardIcon } from 'lucide-react';
export function TrustSignals() {
  const signals = [{
    icon: AwardIcon,
    text: 'Accredited Schools Only',
    detail: 'Quality programs you can trust'
  }, {
    icon: ZapIcon,
    text: 'Flexible and Convenient',
    detail: 'Study on your schedule'
  }, {
    icon: UsersIcon,
    text: '2M+ Students Matched',
    detail: 'Find your path forward'
  }, {
    icon: ShieldCheckIcon,
    text: 'Secure & Private',
    detail: 'Your information is safe'
  }];
  return <div className="w-full bg-white border-y border-gray-200 py-5 shadow-sm" data-id="element-881" data-mp="1759irdadryhc">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-882" data-mp="1c4uukoang1bh">
        <ul className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-x-8 gap-y-5" data-id="element-883" data-mp="1c7gzeg65o2q0">
          {signals.map(signal => {
          const Icon = signal.icon;
          return <li key={signal.text} className="flex items-center gap-3 text-center sm:text-left justify-center sm:justify-start" data-id="element-884" data-mp="rio05ni94lm">
                <div className="p-2 bg-light rounded-full text-navy flex-shrink-0" data-id="element-885" data-mp="ef3hmbpc1gzo">
                  <Icon className="w-5 h-5" aria-hidden="true" data-id="element-886" data-mp="sdtd5mwi78lx" />
                </div>
                <div className="min-w-0" data-id="element-887" data-mp="ndyo7owagt3i">
                  <p className="text-sm font-semibold text-navy leading-tight" data-id="element-888" data-mp="nd5ecf219nh5">
                    {signal.text}
                  </p>
                  <p className="text-xs text-gray-600 mt-0.5 leading-tight" data-id="element-889" data-mp="xcnvyouh0x61">
                    {signal.detail}
                  </p>
                </div>
              </li>;
        })}
        </ul>
      </div>
    </div>;
}